<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import indexPage from '@/pages/Index'

export default {
  name: 'app',
  components: {
    indexPage
  }
}
</script>

<style src="reset-css/reset.css"></style>
<style lang="scss">
  * {
    box-sizing: border-box;
  }

  button {
    padding: 0;
    border: none;
    background: transparent;
    appearance: none;

    &:hover {
      cursor: pointer;
    }

    &:focus {
      outline: none;
    }
  }

  html {
    font: {
      family: sans-serif;
      size: 62.5%;
      feature-settings: "palt" 1;
    }
    line-height: 1;
  }

  body {
    background: #fff000 url("assets/images/bg_dot.svg");
    overflow-x: hidden;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  #app {
    font: {
      family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Segoe UI","Noto Sans Japanese","ヒラギノ角ゴ ProN W3", "Yu Gothic", YuGothic, Verdana, Meiryo, sans-serif;
      weight: 500;
    }
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue?03a9279a